module.exports = __webpack_public_path__ + "static/media/from_dictionary_ru.4dc7d0f7.jpg";